import { createFileRoute, useParams } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";
import { ProjectDetailPage } from "@/components/project/ProjectDetailPage";

export const Route = createFileRoute("/user/_layout/my-projects_/$id")({
  beforeLoad: () => requireFeature("projects"),
  component: MyProjectDetail,
});

function MyProjectDetail() {
  const { id } = useParams({ from: "/user/_layout/my-projects_/$id" });
  return (
    <ProjectDetailPage
      projectId={Number(id)}
      isAdmin={false}
      backTo="/user/my-projects"
      
    />
  );
}
